import './App.css';
import Rutas from './routes/Rutas';
import { WordsProvider } from './contexts/WordsContext';

function App() {
  return (
    <WordsProvider>
      <Rutas />
    </WordsProvider>
  );
}

export default App;
